<template>
	<div class="eia-well">
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'eia-well',
};
</script>

<style lang="scss" scoped>
.eia-well {
	margin: 16px 0;
	border: 1px solid $color-grey-medium;
	padding: 16px;
	border-radius: $radius-default * 0.5;
	box-shadow: inset 0 2px 4px rgba( $color-grey-dark, 0.125 );
	background: $color-grey-light;
}
</style>
